import { render, staticRenderFns } from "./auth-reset.vue?vue&type=template&id=13960418"
import script from "./auth-reset.vue?vue&type=script&lang=js"
export * from "./auth-reset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports